import React from 'react';
import MultiSelectSearchDropdown from '../../Components/MultiFilterSearch/multiFilterSearch';
import PropTypes from 'prop-types';

const StaffAugmentationFilter = ({
  projectOptions,
  statusOptions,
  employeeNameOptions,
  employeeIdOptions,
  staffAugFilterValues,
  handletFilterValues,
}) => {
  return (
    <div className="staff-augmentation-filter-container">
      <MultiSelectSearchDropdown
        dropdownCss="filter-dropdwon"
        options={projectOptions}
        placeholder="Select Opportunities"
        id="staff-aug-project"
        showFilterIcon={false}
        value={staffAugFilterValues.project}
        onChange={(event) => handletFilterValues(event.target.value, 'project')}
        disabled={projectOptions.length === 0}
      />

      <MultiSelectSearchDropdown
        dropdownCss="filter-dropdwon"
        options={statusOptions}
        placeholder="Select Current status"
        id="staff-aug-status"
        showFilterIcon={false}
        value={staffAugFilterValues.status}
        onChange={(event) => handletFilterValues(event.target.value, 'status')}
        disabled={statusOptions.length === 0}
      />

      <MultiSelectSearchDropdown
        dropdownCss="filter-dropdwon-employee"
        options={employeeNameOptions}
        placeholder="Employee Name"
        id="staff-aug-employee-name"
        showFilterIcon={false}
        value={staffAugFilterValues.employeeName}
        onChange={(event) => handletFilterValues(event.target.value, 'employeeName')}
        disabled={employeeNameOptions.length === 0}
      />

      <MultiSelectSearchDropdown
        dropdownCss="filter-dropdwon-employee"
        options={employeeIdOptions}
        placeholder="Employee ID"
        id="staff-aug-employee-id"
        showFilterIcon={false}
        value={staffAugFilterValues.employeeId}
        onChange={(event) => handletFilterValues(event.target.value, 'employeeId')}
        disabled={employeeIdOptions.length === 0}
      />
    </div>
  );
};

StaffAugmentationFilter.propTypes = {
  projectOptions: PropTypes.array.isRequired,
  statusOptions: PropTypes.array.isRequired,
  employeeNameOptions: PropTypes.array.isRequired,
  employeeIdOptions: PropTypes.array.isRequired,
  staffAugFilterValues: PropTypes.array.isRequired,
  handletFilterValues: PropTypes.func.isRequired,
};

export default StaffAugmentationFilter;
